import {strings} from "@atttomyx/shared-utils";

export const unapproved = (trade) => strings.isBlank(trade.tradeWith);

export const approved = (trade) => strings.isNotBlank(trade.tradeWith);
